module.exports = __webpack_public_path__ + "static/view_9-f151715037ee7334f35e64072dd83484.jpg";